<template>
  <div class="merchant-video-upload-wrapper">
    <el-row :gutter="20">
      <el-col :sm="24" :md="12">
        <div style="color: #989898;font-size: 16px;text-align:center">上传视频</div>
        <el-upload
          v-if="url === ''"
          v-loading="videoUploading"
          class="upload-video"
          :action="onUploadUrl"
          :headers="headers"
          drag
          :show-file-list="false"
          :limit="1"
          :on-error="handleVideoError"
          :on-progress="handleVideoProgress"
          :on-success="handleVideoSuccess"
          :before-upload="beforeVideoUpload"
          accept=".mp4, .3gp, .m3u8"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传mp4/3gp/m3u8文件</div>
        </el-upload>
        <!-- 预览图 -->
        <div class="prev-video" v-if="url !== ''">
          <div class="delete-video">
            <i class="el-icon-delete" @click="deleteVideo"></i>
          </div>
          <video :src="url" controls></video>
        </div>
      </el-col>
      <el-col :sm="24" :md="12">
        <div style="color: #989898;font-size: 16px;text-align:center">上传封面图</div>
        <el-upload
          v-if="poster === ''"
          v-loading="posterLoading"
          class="upload-video"
          :action="onUploadUrl"
          :headers="headers"
          drag
          :show-file-list="false"
          :limit="1"
          :on-error="handleVideoPosterError"
          :on-progress="handleVideoPosterProgress"
          :on-success="handleVideoPosterSuccess"
          :before-upload="beforeVideoPosterUpload"
          accept=".jpg, .jpeg, .png"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能传 jpg/jpeg/png 文件</div>
        </el-upload>
        <div class="prev-video" v-if="poster !== ''">
          <div class="delete-video">
            <i class="el-icon-delete" @click="deletePoster"></i>
          </div>
          <el-image :src="poster" :preview-src-list="[poster]"></el-image>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "merchantsVideoUpload",
  props: {
    videoUrl: {
      type: String,
      default: ""
    },
    videoPoster: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      videoUploading: false,
      posterLoading: false,
      url: "",
      poster: ""
    };
  },
	watch:{
		videoUrl(val){
			if(val && val !== ""){
				this.url = val
			}
		},
		videoPoster(val){
			if(val && val !== ""){
				this.poster = val
			}
		}
	},
  computed: {
    onUploadUrl() {
      return this.$api.defaults.baseURL + "/oss/upload";
    },
    headers() {
      return { Authorization: getToken() };
    }
  },
  methods: {
    beforeVideoUpload(file) {
      const isLt30M = file.size / 1024 / 1024 < 30;
      if (!isLt30M) {
        this.$message.error("上传视频大小不能超过 30MB!");
      }
      return isLt30M;
    },
    handleVideoProgress() {
      this.videoUploading = true;
    },
    handleVideoSuccess(res, file) {
      if (res.url) {
        this.url = res.url;
        this.$emit("onChange", { url: this.url, poster: this.poster });
      }
      this.videoUploading = false;
    },
    handleVideoError(err, file, fileList) {
      this.url = "";
      this.$emit("onChange", { url: this.url, poster: this.poster });
      this.videoUploading = false;
      this.$message.error("上传失败");
    },
    deleteVideo() {
      this.$confirm("确定要删除该视频吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.url = "";
        this.$emit("onChange", { url: this.url, poster: this.poster });
      });
    },
    handleVideoPosterError(err, file, fileList) {
      this.poster = "";
      this.$emit("onChange", { url: this.url, poster: this.poster });
      this.posterLoading = false;
      this.$message.error("上传封面图失败");
    },
    handleVideoPosterProgress() {
      this.posterLoading = true;
    },
    handleVideoPosterSuccess(res, file) {
      if (res.url) {
        this.poster = res.url;
        this.$emit("onChange", { url: this.url, poster: this.poster });
      }
      this.posterLoading = false;
    },
    beforeVideoPosterUpload(file) {
      let imageTypes = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = imageTypes.includes(file.type);
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error("上传封面图大小不能超过 1MB!");
      }
      if (!isJPG) {
        this.$message.error("上传封面图格式不符");
      }
      return isLt1M && isJPG;
    },
    deletePoster() {
      this.$confirm("确定要删除该封面图吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.poster = "";
        this.$emit("onChange", { url: this.url, poster: this.poster });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.merchant-video-upload-wrapper {
  padding: 20px 0;
}
.prev-video {
  box-sizing: border-box;
	width: 100%;
  max-width: 360px;
  height: 195px;
  margin: 0 auto;
  padding: 5px;
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 6px;
  text-align: center;
  position: relative;
  overflow: hidden;
  /deep/ {
		.el-image{
			width: 100%;
			height: 100%;
		}
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  video {
    width: 100%;
    height: 100%;
  }
  .delete-video {
    box-sizing: border-box;
    padding: 1px 3px;
    font-size: 22px;
    background-color: rgba($color: #333, $alpha: 0.3);
    color: #f30;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 666;
    transition: all 0.3s linear;
    border-bottom-left-radius: 6px;
    opacity: 0;
  }
  &:hover {
    .delete-video {
      opacity: 1;
    }
  }
}
.upload-video {
  box-sizing: border-box;
	width: 100%;
  max-width: 360px;
  margin: 0 auto;
  min-height: 180px;
  /deep/ {
    .el-upload-dragger {
      box-sizing: border-box;
      padding: 0 20px;
      width: 360px;
      height: auto;
    }
  }
}
</style>